import { render, staticRenderFns } from "./OrgLoader.vue?vue&type=template&id=04fc6088&"
import script from "./OrgLoader.vue?vue&type=script&lang=js&"
export * from "./OrgLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports